import React from 'react';
import PropTypes from 'prop-types';

import './AspectRatioCardTitle.less';

const AspectRatioCardTitle = ({ title }) => {
  return (
    <h4 className="AspectRatioCardTitle">
      {title}
    </h4>
  );
};

AspectRatioCardTitle.propTypes = {
  title: PropTypes.string.isRequired
};

AspectRatioCardTitle.defaultProps = {
  title: ''
};

export default AspectRatioCardTitle;
